<div class="callback-container">
    <h1 class="text-center">{{ title }}</h1>
    <p class="text-center">{{ subtitle }}</p>
</div>
